import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { NotifyError } from 'src/app/pages/pages.actions';
import { PagesState } from 'src/app/pages/pages.model';
import { callerEmail, callerFirstName, callerLastName } from 'src/app/pages/pages.selectors';
import { WSSState } from 'src/app/wss/wss.model';
import { callerId } from 'src/app/wss/wss.selectors';
import { AddUser } from '../training.actions';
import { TrainingState } from '../training.model';
import { gotPatients, user } from '../training.selectors';
import { TrainingService } from '../training.service';

@Component({
  selector: 'sel-patient',
  templateUrl: './sel-patient.component.html',
  styleUrls: ['./sel-patient.component.scss']
})
export class SelPatientComponent {
  patients: any
  patients_keys: string[] = []
  subscriptions: any[] = []
  @Input() isPhoneLS: boolean = false
  sel_patient_id: string | undefined
  caller_email: string | undefined
  caller_first_name: string | undefined
  caller_last_name: string | undefined
  caller_id: string | undefined
  prompt: string = ""
  user: any //The caler
  user_patients: any
  user_patients_keys: string[] = []
  bShowAllPatients: boolean = true
  constructor(
    public pagesState: Store<PagesState>,
    public trainingStore: Store<TrainingState>,
    public training_sevice: TrainingService,
    private wssState: Store<WSSState>,

  ) {
    console.log("sel-patient")

    this.subscriptions.push(this.trainingStore.select(user).subscribe((user: any) => {
      this.user = user
      if (this.user && this.user.patients) {
        this.user_patients = user.patients
        this.user_patients_keys = Object.keys(this.user.patients)
        if (this.user_patients_keys.length > 0) {
          this.bShowAllPatients = false
        }
      }
    }))
    this.subscriptions.push(this.trainingStore.select(gotPatients).subscribe((patients: any) => {
      if (patients) {
        let keys = Object.keys(patients)

        this.patients = patients
        this.patients_keys = keys
      }
    }))

    this.subscriptions.push(this.pagesState.select(callerEmail).subscribe((email: string) => {
      this.caller_email = email
    }))
    this.pagesState.select(callerFirstName).subscribe((name: string | undefined) => {
      this.caller_first_name = name
    })
    this.pagesState.select(callerLastName).subscribe((name: string | undefined) => {
      this.caller_last_name = name
    })
    this.subscriptions.push(this.wssState.select(callerId).subscribe(async (id: string | undefined) => {
      this.caller_id = id
    }))
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }
  async selPatient(patient_id: string) {
    try {
      await this.training_sevice.getPatient(patient_id, this.caller_email)
    } catch (e) {
      if (e == 'email not in users') {
        this.sel_patient_id = patient_id
        this.prompt = "User not in this patient, do you want to add it?"
      }
    }
  }
  async  addUser() {
    if (this.sel_patient_id) {
      let patient = this.patients[this.sel_patient_id]
      let user: any = {
        email: this.caller_email,
        first_name: this.caller_first_name,
        last_name: this.caller_last_name,
        roll: "parent",
        patient_first_name: patient.first_name,
        patient_last_name: patient.last_name,
        patient_id: this.sel_patient_id
      }

      user._id = this.caller_id
      try {
        let new_user = await this.training_sevice.addUser(user)
        this.trainingStore.dispatch(new AddUser(new_user))
        await this.training_sevice.getPatient(this.sel_patient_id, this.caller_email)
        this.cancelAdd();
      } catch (e: any) {
        console.error(e)
        // console.error(e)
        let err = "Error"
        if (e.error.error) {
          err = e.error.error
        } else if (e.error) {
          err = e.error
        }
        this.pagesState.dispatch(new NotifyError(err))
      }
    }
  }
  cancelAdd() {
    this.prompt = ""
    this.sel_patient_id = undefined
  }
}
